import "./App.css";
import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import Cards from "./components/Cards";
import Search from "./components/Search";
import Brands from "./components/Brands";
import Footer from "./components/Footer";
function App() {
  return (
    <>
      <Navbar />
      <Banner />
      <Cards />
      <Search />
      <Brands />
      <Footer />
    </>
  );
}

export default App;
